/* eslint-disable internal-rules/no-restricted-design-system-imports */
/* eslint-disable internal-rules/no-restricted-design-system-props */

import { useState } from 'react';

import { Waypoint } from 'react-waypoint';

import { SocialSharing, SocialSharingGroup } from '@change/ds-core-ui';
import type { Icon } from '@change/ds-icons';
import { EmailOutlineIcon, FacebookRegularIcon, TwitterIcon, WhatsAppIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useShareLinks } from './hooks/useShareLinks';
import type { Channel } from './hooks/useShareLinks/types';

export function ShareLinks() {
	const [visible, setVisible] = useState(false);
	const {
		data: { shareActions },
	} = useShareLinks({ disableShortLinks: !visible });

	return (
		<>
			<Waypoint onEnter={() => setVisible(true)} />
			<SocialSharingGroup className="mb-0 mt-6 flex flex-wrap gap-1 md:justify-start">
				{shareActions.map(({ channel, ShareAction }) => (
					<ShareAction key={`share-icon-${channel}`}>
						<ShareIcon channel={channel} />
					</ShareAction>
				))}
			</SocialSharingGroup>
		</>
	);
}

const socialIcons: Readonly<
	Record<
		Channel,
		Readonly<{
			icon: React.FC<Icon>;
			displayLabel: string;
		}>
	>
> = {
	facebook: {
		icon: FacebookRegularIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.facebook',
	},
	twitter: {
		icon: TwitterIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.twitter',
	},
	whatsapp: {
		icon: WhatsAppIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.whatsapp',
	},
	email: {
		icon: EmailOutlineIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.email',
	},
} as const;

function ShareIcon({ channel, onClick }: { channel: Channel | undefined; onClick?: () => void }) {
	const { translate } = useI18n();
	const { icon: IconComponent, displayLabel } = socialIcons[channel as keyof typeof socialIcons];
	const variant = channel === 'email' ? 'default' : channel;
	return (
		<SocialSharing
			data-testid={`share-icon-${channel}`}
			icon={<IconComponent />}
			label={translate(displayLabel as unknown as TranslationKey)}
			onClick={onClick}
			size="large"
			variant={variant}
		/>
	);
}
